import { FieldLabel } from "./FieldLabel";
import { fieldBase, fieldStyle, applyFocus, applyBlur } from "./fieldStyles";

export function FormSelect({
  label,
  name,
  options,
  required,
  index,
  testId,
  defaultValue = "",
}) {
  return (
    <div>
      <FieldLabel htmlFor={name} required={required} index={index}>
        {label}
      </FieldLabel>
      <select
        id={name}
        name={name}
        required={required}
        defaultValue={defaultValue}
        data-testid={testId}
        className={`${fieldBase} appearance-none pr-10 cursor-pointer`}
        style={{
          ...fieldStyle,
          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'><path d='M1 1l5 5 5-5' stroke='%23A88A57' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/></svg>")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 14px center",
        }}
        onFocus={applyFocus}
        onBlur={applyBlur}
      >
        <option value="" disabled>
          Select…
        </option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
}
